var _rect, _rect2, _circle, _circle2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoutineTracker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 25.5,
    fill: "url(#paint0_linear_0_1)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 63.5,
    r: 25.5,
    fill: "url(#paint1_linear_0_1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 40.5556,
    width: 16.3421,
    height: 50.7944,
    rx: 8.17105,
    transform: "rotate(-45 29 40.5556)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 16,
    y1: 16,
    x2: 67,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33E745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 39,
    y1: 38,
    x2: 90,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#3C82D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E73333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutineTracker);
export default __webpack_public_path__ + "static/media/Routine Tracker.415624eeff85c1facb22d83d18ef330a.svg";
export { ForwardRef as ReactComponent };